import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import viewedHotelsAction from '../actions/viewedHotels';
import ViewedHotels from '../../../helpers/ViewedHotels';

class ViewedHotelsUpdater extends PureComponent {
  constructor(props) {
    super(props);
    this.storageListener = this.storageListener.bind(this);
  }

  componentDidMount() {
    this.updateViewed();
    window.addEventListener('storage', this.storageListener);
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.storageListener);
  }

  storageListener(e) {
    if (e.key === ViewedHotels.KEY) {
      this.updateViewed();
    }
  }

  updateViewed() {
    const { setViewed } = this.props;
    setViewed(ViewedHotels.viewed);
  }

  render() {
    return null;
  }
}

ViewedHotelsUpdater.propTypes = {
  setViewed: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setViewed: (viewedHotels) => dispatch(viewedHotelsAction(viewedHotels)),
});

export default connect(null, mapDispatchToProps)(ViewedHotelsUpdater);
